// Base class and common properties for all analytics events.
export abstract class SurveyAnalyticsEvent {
  abstract type: string;
  sourceId: string;
  surveyId: string;
  patientId: string;
  deviceSerial: string;
  origin: string = 'myair' // Hardcoded for now since myAir is the only client.
  dateTime: string = new Date().toISOString();
}